import * as React from 'react';
import {
  DefaultButton,
  DialogActions,
  DialogContent,
  DialogContentText,
  PrimaryButton,
} from '@bb-ui/react-library';
import { Dialog } from '@bb-ui/react-library/dist/components/Dialog';
import { DialogTitle } from '@bb-ui/react-library/dist/components/DialogTitle';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';

export interface MassQueryToolingAgreementDialogProps {
  open: boolean;
  onAgree: () => void;
}

export const MassQueryToolingAgreementDialog: React.FunctionComponent<
  MassQueryToolingAgreementDialogProps
> = ({ open, onAgree }) => {
  const { t } = useTranslation();
  const history = useHistory();

  const handleDisagree = () => {
    history.push('/');
  };

  const handleClose = (reason: 'backdropClick' | 'escapeKeyDown') => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
      // Do nothing to prevent closing the dialog
    }
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle hideCloseButton closeLabel={t('global.close')}>
        {t('massQueryTooling.agreementDialog.title')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>{t('massQueryTooling.agreementDialog.content')}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <DefaultButton onClick={handleDisagree}>
          {t('massQueryTooling.agreementDialog.disagree')}
        </DefaultButton>
        <PrimaryButton onClick={onAgree}>
          {t('massQueryTooling.agreementDialog.agree')}
        </PrimaryButton>
      </DialogActions>
    </Dialog>
  );
};

export default MassQueryToolingAgreementDialog;
